// @core/api/endpoints/billing/void_credit_grant.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  VoidCreditGrantRequest,
  VoidCreditGrantResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Void credit grant
 * Voids an unused credit grant, removing it from the billing account's available balance. Applied credits cannot be voided.
 */
export async function VoidCreditGrant(
  id: string,
  data: VoidCreditGrantRequest,
  options?: RequestOptions
): Promise<VoidCreditGrantResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/credits/:id/void`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.post<VoidCreditGrantResponse>(requestPath, data, requestOptions);
}
